import router from "./router";
import "core-js/stable";
import "./plugins";
import "./config";
import "vuetify-dialog/dist/vuetify-dialog.css";

import App from "./App.vue";
import TextHighlight from "vue-text-highlight";
import Vue from "vue";
import VuetifyDialog from "vuetify-dialog";
import cssVars from "css-vars-ponyfill";
import i18n from "./plugins/i18n";
import store from "./store";
import vuetify from "./plugins/vuetify";

import { showToaster, showConfirm, showNotification } from "~/notifications";

import "./scss/app.scss";
if (navigator.platform == "Win32") import("./scss/scrollbar.scss");

Vue.config.productionTip = false;

cssVars({});

global.EventBus = new Vue({
  i18n
});

Vue.component("text-highlight", TextHighlight);

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
    store,
    router,
    i18n
  },
  confirm: {
    actions: {
      false: {
        text: "No",
        color: "primary",
        outline: true
      },
      true: {
        text: "Si",
        color: "primary"
      }
    },
    icon: true
  }
});

Vue.mixin({
  data() {
    // eslint-disable-next-line no-debugger
    return {
      cordovaPlatform: process.env.CORDOVA_PLATFORM,
      isCordova: typeof process.env.CORDOVA_PLATFORM != "undefined"
    };
  },
  computed: {
    //@deprecated use isCordova instead
    $platform_is_cordova: () => typeof cordova !== "undefined"
  }
});

Vue.prototype.$dialog.on("shown", ({ dialog }) => {
  global.config.dialogs.push(dialog);
});

Vue.prototype.$dialog.on("destroyed", ({ dialog }) => {
  global.config.dialogs = global.config.dialogs.filter(
    _dialog => _dialog.id !== dialog.id
  );
});

Vue.prototype.$dialog.clearDialogs = () => {
  global.config.dialogs.forEach(_dialog => _dialog.remove());
  global.config.dialogs = [];
};

const vm = new Vue({
  router,
  store,
  vuetify,
  i18n,

  render: h => h(App)
}).$mount("#app");

global.vm = vm;

const toastedOption = {
  position: "top-center",
  duration: 3000,
  iconPack: "mdi",
  theme: "bubble",
  keepOnHover: true,
  top: true,
  action: {
    icon: "$clear",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
};
global.EventBus.$on("error", payload => {
  showToaster("error", payload, toastedOption);
});
global.EventBus.$on("warning", payload => {
  showToaster("warning", payload, toastedOption);
});
global.EventBus.$on("success", payload => {
  showToaster("success", payload, toastedOption);
});

global.EventBus.$on("confirm", showConfirm);

global.EventBus.$on("notification", showNotification);

global.EventBus.$on("toggleModal", isModalOpened => {
  let cartRightDrawer = document.getElementById("cart-right-drawer");
  let wInnerHeight = window.innerHeight;
  cartRightDrawer.style.height = wInnerHeight + "px";
  if (isModalOpened) {
    if (document.body.style.position != "fixed") {
      let scrollY = "-" + parseInt(window.scrollY) + "px";
      document.body.classList.add("modal-open");
      document.body.style.position = "fixed";
      document.body.style.top = scrollY;
    }
  } else {
    document.body.style.position = "";
    document.body.classList.remove("modal-open");
    let bodyTop = document.body.style.top.replace("px", "");
    let numberY = Math.abs(parseInt(bodyTop));
    document.body.style.top = "";
    window.scrollTo(0, numberY);
  }
});

window.addEventListener(
  "resize",
  function() {
    let cartRightDrawer = document.getElementById("cart-right-drawer");
    let wInnerHeight = window.innerHeight;
    cartRightDrawer.style.height = wInnerHeight + "px";
  },
  true
);

window.handleOpenURL = function(url) {
  setTimeout(() => {
    console.log("::::: window.handleOpenURL ::::: ", url);
    console.log("::::: window.handleOpenURL store ::::: ", store);
    store.dispatch("handleOpenUrl", {
      url: url
    });
  });
};
